import React from 'react';
import { List, Tooltip, Typography } from 'antd';
import type { ReactNode } from 'react';

type MenuItem = {
  text: string;
  icon?: ReactNode;
  click?: (e: any) => void;
  disabled?: boolean;
  className?: string;
  description?: string;
  iconColor?: string;
};

type ActionMenuProps = {
  menuItems: MenuItem[];
  onMenuClick?: (menuItem: MenuItem) => void;
  listClassName?: string;
  itemClassName?: string;
};

export const ActionMenu: React.FC<ActionMenuProps> = ({
  menuItems,
  onMenuClick,
  listClassName = 'action-menu bg-white',
  itemClassName = 'flex cursor-pointer !justify-start gap-2 font-[550]',
}) => {
  return (
    <List
      className={listClassName}
      size="small"
      dataSource={menuItems}
      renderItem={(item: MenuItem) => (
        <Tooltip title={item.description} placement="right">
          <List.Item
            onClick={(e: any) => {
              if (!item.disabled && item.click) item.click(e);
              if (!item.disabled && onMenuClick) onMenuClick(item);
            }}
            className={`${itemClassName} ${item.disabled ? 'cursor-not-allowed opacity-50' : ''} ${item.className}`}
          >
            <Typography.Text style={{ color: item.iconColor || 'inherit' }}>
              {item.icon}
            </Typography.Text>
            <span className="text-primary-font-gray">{item.text}</span>
          </List.Item>
        </Tooltip>
      )}
    />
  );
};
